import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-e03cb5c3.js';
import { c as cjs } from './index-9afb3677.js';
import { g as getNamespacedTagFor } from './index-2dc281eb.js';

const marketHeaderCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}::slotted(.wayfinding),::slotted([slot=\"wayfinding\"]),::slotted(.subheading),::slotted([slot=\"subheading\"]){font-weight:var(--core-type-paragraph-20-weight);font-size:var(--core-type-paragraph-20-size);font-family:var(--core-type-paragraph-20-font-family);line-height:var(--core-type-paragraph-20-leading);letter-spacing:var(--core-type-paragraph-20-tracking);text-transform:var(--core-type-paragraph-20-case)}::slotted(.wayfinding) b,::slotted(.wayfinding) strong,::slotted([slot=\"wayfinding\"]) b,::slotted([slot=\"wayfinding\"]) strong,::slotted(.subheading) b,::slotted(.subheading) strong,::slotted([slot=\"subheading\"]) b,::slotted([slot=\"subheading\"]) strong{font-weight:var(--core-type-semibold-20-weight)}:host{--header-animation-duration:0.2s;display:block}::slotted(*){margin:0}::slotted(.wayfinding),::slotted([slot=\"wayfinding\"]){display:block;margin-bottom:var(--header-sub-text-spacing-bottom-size);color:var(--header-sub-text-text-color)}::slotted(.subheading),::slotted([slot=\"subheading\"]){display:block;margin-top:var(--header-sub-text-spacing-bottom-size);color:var(--header-sub-text-text-color)}:host([show-navigation]) ::slotted([slot=\"compact\"]:not(.wayfinding):not(.subheading)){font-weight:var(--core-type-heading-20-weight);font-size:var(--core-type-heading-20-size);font-family:var(--core-type-heading-20-font-family);line-height:var(--core-type-heading-20-leading);letter-spacing:var(--core-type-heading-20-tracking);text-transform:var(--core-type-heading-20-case)}nav{padding-right:var(--header-main-text-horizontal-spacing)}menu{display:none;grid-auto-flow:column;align-items:start;margin:0;padding-left:var(--header-main-text-horizontal-spacing);-moz-column-gap:var(--button-group-spacing);column-gap:var(--button-group-spacing)}:host([show-actions]) menu{display:grid}.grid{display:none}:host([show-actions]) .grid{display:grid;grid-template-columns:auto minmax(max-content, 1fr)}:host([show-navigation]) .grid{display:grid;grid-template-columns:minmax(max-content, 1fr) auto minmax(max-content, 1fr)}.navigation{display:none}:host([show-navigation]) .navigation{display:flex}.actions{display:flex;place-content:flex-end}.compact{display:flex;flex-direction:column;place-content:center}::slotted(p){margin-top:var(--header-bottom-padding-size)}::slotted(p[slot=\"compact\"]){display:none}:host([show-navigation]) .compact{overflow:hidden;text-align:center;opacity:0%;visibility:hidden;transition:opacity var(--header-animation-duration) ease-in-out,\n    visibility 0s linear var(--header-animation-duration)}:host([show-navigation]) .compact ::slotted([slot=\"compact\"]){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.heading{display:block;transition:opacity var(--header-animation-duration) ease-in-out, visibility 0s}:host([show-navigation]) .heading{margin-top:var(--header-nav-icon-button-spacing-buttom-size)}:host([show-actions]:not([show-navigation])) .heading{display:none}:host([show-navigation][compact]) .compact{opacity:100%;visibility:visible;transition:opacity var(--header-animation-duration) ease-in-out, visibility 0s}:host([show-navigation][compact]) .heading{opacity:0%;visibility:hidden;transition:opacity var(--header-animation-duration) ease-in-out,\n      visibility 0s linear var(--header-animation-duration)}:host(.regular) .heading{max-width:var(--modal-full-fixed-layout-width);margin-right:auto;margin-left:auto}:host(.wide) .heading{max-width:1200px;margin-right:auto;margin-left:auto}";
const MarketHeaderStyle0 = marketHeaderCss;

const MarketHeader = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.marketHeaderNavigate = createEvent(this, "marketHeaderNavigate", 7);
        this.showNavigation = null;
        this.closeButtonAriaLabel = 'Close';
        this.disableCloseButton = false;
        this.compact = false;
        this.compactTitle = undefined;
        this.hideCompactWayfinding = false;
        this.showActions = false;
    }
    handleCompact() {
        if (this.compact) {
            const compact = this.el.shadowRoot.querySelector('.grid .compact');
            const minHeight = Number.parseInt(getComputedStyle(compact).height, 10);
            this.el.style.height = minHeight !== undefined ? `${minHeight}px` : '';
        }
        else {
            this.el.style.height = '';
        }
    }
    handleSlottedNavigation() {
        // If there is custom navigation passed in, we need to
        // attach event handlers to the slotted elements manually
        const customNavEl = this.el.querySelector('[slot="navigation"]');
        if (customNavEl) {
            this.showNavigation = true;
            customNavEl.addEventListener('click', this.handleSlottedNavClick.bind(this));
        }
    }
    handleSlottedActions() {
        const actions = this.el.querySelector('[slot="actions"]');
        this.showActions = actions ? true : false;
    }
    handleCloseButtonClick(event) {
        this.marketHeaderNavigate.emit({
            event,
            action: 'close',
        });
    }
    handleSlottedNavClick(event) {
        this.marketHeaderNavigate.emit({
            event,
            action: 'custom',
        });
    }
    componentWillRender() {
        this.checkForNavigation();
        this.cloneDefaultHeadingToCompactHeading();
        // watch for changes in slotted children content
        const observer = new MutationObserver(this.handleMutation.bind(this));
        observer.observe(this.el, { childList: true, characterData: true, subtree: true });
    }
    componentDidRender() {
        // this function requires layout computation,
        // so we need to wait until render to call.
        this.handleCompact();
    }
    handleMutation(mutationList) {
        // We don't want to re-clone the default slot content if
        // the mutation was already the result of the cloning
        // because then we would get into an infinite loop!
        // So we have to look at the mutation data to check if a
        // compact slotted element was added to prevent re-cloning.
        let shouldClone = true;
        mutationList.forEach((mutation) => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach((node) => {
                    if (node.slot === 'compact') {
                        shouldClone = false;
                    }
                });
            }
        });
        if (shouldClone) {
            this.cloneDefaultHeadingToCompactHeading();
        }
    }
    checkForNavigation() {
        // We want to force the header to be navigable when slotted in modals
        const hasModalParent = this.el.closest(`
      ${getNamespacedTagFor('market-modal-full')},
      ${getNamespacedTagFor('market-modal-partial')}
    `);
        // The same if custom navigation is slotted in
        const hasCustomNavigation = this.el.querySelector('[slot="navigation"]');
        // Only set this if the prop hasn't been passed in manually
        if (this.showNavigation === null) {
            this.showNavigation = hasModalParent || hasCustomNavigation ? true : false;
        }
    }
    cloneDefaultHeadingToCompactHeading() {
        // clear existing compact slotted content
        const compactSlottedContent = this.el.querySelectorAll('[slot="compact"]');
        for (const node of compactSlottedContent) {
            this.el.removeChild(node);
        }
        // clone the wayfinding or subheading slot into compact slot
        const wayfindingEl = this.el.querySelector('[slot="wayfinding"]');
        const subheadingEl = this.el.querySelector('[slot="subheading"]');
        if (wayfindingEl && !this.hideCompactWayfinding) {
            const clone = wayfindingEl.cloneNode(true);
            clone.slot = 'compact';
            clone.classList.add('wayfinding');
            this.el.appendChild(clone);
        }
        const defaultSlotContent = [...this.el.children].filter((el) => !el.getAttribute('slot'));
        if (this.compactTitle) {
            // we assume there's only slotted header tag in this case
            const compactTitleEl = defaultSlotContent[0].cloneNode(true);
            compactTitleEl.textContent = this.compactTitle;
            compactTitleEl.slot = 'compact';
            this.el.appendChild(compactTitleEl);
        }
        else {
            // clone the rest of the default slot content into compact slot
            for (const node of defaultSlotContent) {
                const clone = node.cloneNode(true);
                clone.slot = 'compact';
                this.el.appendChild(clone);
            }
        }
        if (!wayfindingEl && subheadingEl) {
            const clone = subheadingEl.cloneNode(true);
            clone.slot = 'compact';
            clone.classList.add('subheading');
            this.el.appendChild(clone);
        }
    }
    renderDefaultNavigation() {
        const MarketButtonTagName = getNamespacedTagFor('market-button');
        const MarketIconTagName = getNamespacedTagFor('market-icon');
        return (h(MarketButtonTagName, { rank: "secondary", slot: "navigation", "aria-label": this.closeButtonAriaLabel, disabled: this.disableCloseButton, onClick: (event) => this.handleCloseButtonClick(event) }, h(MarketIconTagName, { slot: "icon", name: cjs.HEADER_CLOSE_BUTTON_ICON_ASSET })));
    }
    render() {
        return (h(Host, { key: '29a30e2a5bd91ab6c17f43e72321c6743e8c797b', class: "market-header", "show-actions": this.showActions }, h("div", { key: '13a2d256689a5e4e7f8e68de77e91dd6b2612a56', class: "grid" }, h("div", { key: 'ce4f1151783ba0e7c50d1d6cd5576799c0f7333b', class: "navigation" }, h("nav", { key: '8f28c54ca70a70a084ed34def03f11fc75de7473' }, h("slot", { key: '210cef1e404f3155c1f0a221976af8841cf49d6a', name: "navigation", onSlotchange: () => this.handleSlottedNavigation() }, this.renderDefaultNavigation()))), h("div", { key: 'f46bc03453124b73e585590c04ebdc5135526764', class: "compact" }, h("slot", { key: '9f3c7b4e12d00ddac6c5dcf22066cd3eabf12700', name: "compact" })), h("div", { key: '2ac941d01391bca204c054eaea883cab4b03995e', class: "actions" }, h("menu", { key: '1a219d7c4b1dd742d74ba5e9dac51645abc86d6e' }, h("slot", { key: 'aecf0c052ed076dde3401bf4648a75574a2a76ff', name: "actions", onSlotchange: () => this.handleSlottedActions() })))), h("div", { key: '9a730f2b2419b62f03c051e6463e35215d9c46b5', class: "heading", part: "heading" }, h("slot", { key: '5b661f3a6de16d18427cc186c2ec9db68c4955f1', name: "wayfinding" }), h("slot", { key: '7bc8b222cb4490ea3ced00c9e9acc65860244c27' }), h("slot", { key: '54318611a7704a7c832342b586585fd70a012065', name: "subheading" }))));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "compact": ["handleCompact"]
    }; }
};
MarketHeader.style = MarketHeaderStyle0;

export { MarketHeader as market_header };

//# sourceMappingURL=market-header.entry.js.map